import FastAPIClient from "./services/apiClient"
import config from "./config"
export const API_BASE_PATH = `${config.apiBasePath}/api/v1`
export const client = new FastAPIClient()

export const postSalesInquiry = async (payload) => {
    const data = client.postData('/website/contact-sales', payload)
    return data
}

export const postGeneralInquiry = async (payload) => {
    const data = client.postData('/website/contact-us', payload)
    return data
}